<!-- slick Slider js START -->
    
  jQuery( document ).ready(function() {
    $('.delight-slides').slick({
      dots: true,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      arrows: false
    });
    
    $('.review-slider').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: false,
         adaptiveHeight: true
    });

    

    jQuery(".read-more-btn").click(function(event){
      event.preventDefault();
      jQuery(".accordian-content").slideDown(500);
      jQuery(".read-more-btn").hide();
      jQuery(".read-less-btn").show();
    });
    
    jQuery(".read-less-btn").click(function(event){
         event.preventDefault();
         jQuery(".accordian-content").slideUp(500);
         jQuery(".read-more-btn").show();
         jQuery(".read-less-btn").hide();
    })

    jQuery(".accordion_head").click(function(event){
      event.preventDefault();
      jQuery(this).siblings(".accordion_body").toggle('slow');
    });




    
  });
<!-- slick Slider js END -->



jQuery( document ).ready(function() {
jQuery( ".product-form__quantity" ).insertBefore( "div#price-template--23776945340703__main" );
  jQuery( ".product-form__quantity" ).insertBefore( "#price-template--23800826888479__main" );
  jQuery( ".main-product-tab" ).insertAfter( "a.link.product__view-details.animate-arrow" );
});



// Product-tab Js START
function openCity(evt, cityName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(cityName).style.display = "block";
  evt.currentTarget.className += " active";
}
// Product-tab Js END




// Open cart drawer after add to cart button is clicked

const myInterval = setInterval(myTimer, 1000);

function myTimer() {
  const date = new Date();
  $('.hktqv_Product__CTA__AddToCart__Btn').on('click', function(){
    setTimeout(function(){ $('.drawer').addClass('active'); }, 1500);
  });
}

function myStopFunction() {
  clearInterval(myInterval);
}




